import { ChainId, Token } from '@pancakeswap/sdk'
import { serializeToken } from 'state/user/hooks/helpers'
import { SerializedToken } from './types'

const { MAINNET, TESTNET } = ChainId

interface TokenList {
  [symbol: string]: Token
}

interface SerializedTokenList {
  [symbol: string]: SerializedToken
}

export const mainnetTokens = {
  weth: new Token(
    MAINNET,
    '0x33e22F85CC1877697773ca5c85988663388883A0',
    18,
    'WBESC',
    'Wrapped BESC',
    'https://www.bescfinanical.com/',
  ),
  eth: new Token(MAINNET, '0x33e22F85CC1877697773ca5c85988663388883A0', 18, 'BESC', 'BESC', 'https://www.binance.com/'),
  cake: new Token(
    MAINNET,
    '0xf794E0B0c0a91099ccAcac296193e04Fb860442a',
    18,
    'MONEY',
    'MONEY',
    'https://bescswap.com/',
  ),
  usdc: new Token(
    MAINNET,
    '0xB54aD626E127f0f228dBeab6F2A61e8e6e029A4B',
    18,
    'BUSDC',
    'BUSDC',
    'https://www.paxos.com/busd/',
  ),
  BMT: new Token(
    MAINNET,
    '0x6EDb89ca166891937bfE6C0FB73E7d06482BE2BB',
    18,
    'BESC MONEY TRICKLE',
    'BMT',
    'https://www.paxos.com/busd/',
  ),
  MSMIL: new Token(
    MAINNET,
    '0x32c66fCB34229dad04651B8253CC8bADBF0D803d',
    18,
    'MilestoneMillions',
    'MSMIL',
    'https://www.bescswap.com/msmill/',
  ),
}

export const testnetTokens = {
  wbnb: new Token(
    TESTNET,
    '0x094616F0BdFB0b526bD735Bf66Eca0Ad254ca81F',
    18,
    'bnb',
    'Wrapped WBESC',
    'https://www.binance.com/',
  ),
  cake: new Token(
    TESTNET,
    '0xa35062141Fa33BCA92Ce69FeD37D0E8908868AAe',
    18,
    'MONEY',
    'wbescSwap Token',
    'https://bescswap.com/',
  ),
  busd: new Token(
    TESTNET,
    '0xeD24FC36d5Ee211Ea25A80239Fb8C4Cfd80f12Ee',
    18,
    'BUSD',
    'Binance USD',
    'https://www.paxos.com/busd/',
  ),
  syrup: new Token(
    TESTNET,
    '0xfE1e507CeB712BDe086f3579d2c03248b2dB77f9',
    18,
    'SYRUP',
    'SyrupBar Token',
    'https://bescswap.com/',
  ),
  bake: new Token(
    TESTNET,
    '0xE02dF9e3e622DeBdD69fb838bB799E3F168902c5',
    18,
    'BAKE',
    'Bakeryswap Token',
    'https://www.bakeryswap.org/',
  ),
}

const tokens = (): TokenList => {
  const chainId = process.env.REACT_APP_CHAIN_ID

  // If testnet - return list comprised of testnetTokens wherever they exist, and mainnetTokens where they don't
  if (parseInt(chainId, 10) === ChainId.TESTNET) {
    return Object.keys(mainnetTokens).reduce((accum, key) => {
      return { ...accum, [key]: testnetTokens[key] || mainnetTokens[key] }
    }, {})
  }

  return mainnetTokens
}

export const serializeTokens = (): SerializedTokenList => {
  const unserializedTokens = tokens()
  const serializedTokens = Object.keys(unserializedTokens).reduce((accum, key) => {
    return { ...accum, [key]: serializeToken(unserializedTokens[key]) }
  }, {})

  return serializedTokens
}

export default tokens()